export default "__VITE_ASSET__DMaCShb0__"